'use client';

import { P } from '@/components/ui/typography';
import React from 'react';

export const PhoneSupportExplanation = () => {
  const [expanded, setExpanded] = React.useState(false);

  const onExpand = () => {
    setExpanded(!expanded);
  };

  return (
    <div className="flex flex-col gap-3 items-start">
      <button className="underline cursor-pointer" onClick={onExpand}>
        Why don&rsquo;t we offer support over the phone?
      </button>
      {expanded && (
        <>
          <P className="max-w-xl">
            We provide support via email instead of phone so that we can quickly direct you to the
            team member who is best suited to answering your question, so that we have a clear
            record of all of your questions and what we&apos;ve suggested, and most of all because
            after more than a decade of supporting QLab we know that it gets you better help,
            faster. We&apos;re looking forward to hearing from you!
          </P>
        </>
      )}
    </div>
  );
};
